<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="pawline"><span class="x30-pt-charlemagne" style="font-size:1em;"><img alt="pawline.eps" class="image" src="images/pawline_fmt.png" width="100%"/></span></p>
<p class="x1tocgrey" id="toc_marker-7">Contents<a id="x-contents-"></a></p><a id="x-contents-">
</a><p class="toc1"><a id="x-contents-"></a><span href="#/Acks#Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc1a"><a href="#/Intro#Introduction">Introduction</a></p>
<p class="TOC-chapter-title">The Wisdom of Cats </p>
<p class="toc1"><a href="#/EnCatbook#Chapter-One">Chapter One</a></p>
<p class="TOC-chapter-title">Cat Deities and the Feminine Mystique </p>
<p class="toc1"><a href="#/EnCatbook1#Chapter-Two">Chapter Two</a></p>
<p class="TOC-chapter-title">Elemental Feline Folklore and Divination </p>
<p class="toc1"><a href="#/EnCatbook2#Chapter-Three">Chapter Three</a></p>
<p class="TOC-chapter-title">Cat Magick, Candle Spells, and Astrology </p>
<p class="toc1"><a href="#/EnCatbook3#Chapter-Four">Chapter Four</a></p>
<p class="TOC-chapter-title">Feline Power Animals </p>
<p class="toc1"><a href="#/EnCatbook4#Chapter-Five">Chapter Five</a></p>
<p class="TOC-chapter-title">The Feline Familiar </p>
<p class="toc1"><a href="#/EnCatbook5#Chapter-Six">Chapter Six</a></p>
<p class="TOC-chapter-title">Charms and Spells for Your Cat </p>
<p class="toc1"><a href="#/EnCatbook6#Cat-Magick-Journal">Cat Magick Journal</a></p>
<p class="toc1"><a href="#/EnCatbook7#Bibliography">Bibliography</a></p>
<p class="No-Paragraph-Style para-style-override-2"><span class="char-style-override-3"><img alt="Ch5.tif" class="Basic-Graphics-Frame" src="images/Ch5_fmt.png" width="100%"/></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?291437b2